import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  ShamVisaPaymentIcon,
  ShamDiscoverPaymentIcon,
  ShamApplePayIcon,
  ShamMastercardPaymentIcon,
  ShamSecurePaymentIcon,
  ShamSocialFacebook1Icon,
  ShamSocialTwitter1Icon,
  ShamSocialPinterest1Icon,
  ShamSocialInstagram1Icon,
  ShamPlaystoreIcon,
  ShamAppleIcon,
} from 'sham-components/icons';
import { SELLER_DASH_URL } from '@/environments/environment';

@Component({
  selector: 'app-main-footer',
  imports: [
    ShamVisaPaymentIcon,
    ShamDiscoverPaymentIcon,
    ShamApplePayIcon,
    ShamMastercardPaymentIcon,
    ShamSecurePaymentIcon,
    ShamSocialFacebook1Icon,
    ShamSocialTwitter1Icon,
    ShamSocialPinterest1Icon,
    ShamSocialInstagram1Icon,
    ShamPlaystoreIcon,
    ShamAppleIcon,
    TranslateModule,
    RouterLinkWithHref,
  ],
  templateUrl: './main-footer.html',
  styleUrl: './main-footer.css',
})
export class MainFooter implements AfterViewInit {
  sellerDashboardUrl = SELLER_DASH_URL;
  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('f-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    observer.observe(this.el.nativeElement);
  }
}
